<template>
  <div id="app">
    <div>
      <Loader />
      <router-view/>
    </div>
  </div>
</template>
<script>

import Loader from "@/components/layout/Loader";
export default {
  components: {Loader},
  beforeMount() {
    if (!routeExceptions.includes(this.name)) {
      this.$store.dispatch('syncData');
    }
  },
  computed: {

  },
  data() {
    return {
      name: this.$route.name
    }
  }
}
</script>
<style lang="scss">
@import "assets/css/styles";
</style>
